import SuperRepository from '../superRepository'

export default new (class CurrenciesRepository extends SuperRepository {
  baseUri() {
    return 'currency'
  }
})()
